import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../../state/actions'
import * as storage from '../../../utils/storage'
import { Link } from 'react-router'

import {
    Alert
} from 'react-bootstrap'

import {
    Container,
    Form,
    FormGroup,
    ControlLabel
} from './styles'

import { Translate } from 'react-localize-redux'

class GlobalConfig extends Component {
    constructor(props) {
        super(props)

        this.handleChangeBot = this.handleChangeBot.bind(this)
        this.handleChangeLanguage = this.handleChangeLanguage.bind(this)
        this.handleChangeModule = this.handleChangeModule.bind(this)
    }

    // Helper: Verifica si hay múltiples módulos disponibles
    hasMultipleModules(botSelected) {
        return botSelected &&
               botSelected.ai &&
               botSelected.ai.nlp &&
               Array.isArray(botSelected.ai.nlp) &&
               botSelected.ai.nlp.length > 1
    }

    // Helper: Obtiene el primer módulo válido
    getFirstModule(botSelected) {
        if (botSelected && botSelected.ai && botSelected.ai.nlp && Array.isArray(botSelected.ai.nlp) && botSelected.ai.nlp.length > 0) {
            const firstModule = botSelected.ai.nlp[0]
            if (firstModule && firstModule.name && (firstModule.nlp || firstModule.intents || firstModule.entities)) {
                return {
                    name: firstModule.name,
                    nlp: firstModule.nlp,
                    intents: firstModule.intents,
                    entities: firstModule.entities
                }
            }
        }
        return null
    }

    componentDidMount() {
        return this.getGlobalConfig()
    }

    async getGlobalConfig() {
        try {
            await this.props.actions.getGlobalConfig(this.props.codename)
            const storageBotSelected = storage.get('botSelected')
            const botSelected = this.props.globalConfig && this.props.globalConfig.length && ((storageBotSelected && this.props.globalConfig.find(config => config.bot === storageBotSelected)) || this.props.globalConfig[0]) || null
            if (botSelected) {
                this.props.actions.selectBot(botSelected)
                const storageLanguageSelected = storage.get('nlpSelected')
                const firstModule = this.getFirstModule(botSelected)
                if (firstModule) {
                    this.props.actions.selectModule(firstModule)
                }
                const nlpSelected = botSelected.languages && botSelected.languages.length && ((storageLanguageSelected && botSelected.languages.find(language => language.language === storageLanguageSelected)) || botSelected.languages.find(language => language.setup) || botSelected.languages[0]) || null
                if (nlpSelected) {
                    this.props.actions.selectNlpModule(nlpSelected)
                }
            }
        } catch (error) {
            // ...
        }
    }

    handleChangeBot(e) {
        const value = e.target.value
        const botSelected = this.props.globalConfig.find(config => config.bot === value)
        if (botSelected) {
            this.props.actions.selectBot(botSelected)
            const storageLanguageSelected = storage.get('nlpSelected')
            const nlpSelected = botSelected.languages && botSelected.languages.length && ((storageLanguageSelected && botSelected.languages.find(language => language.language === storageLanguageSelected)) || botSelected.languages.find(language => language.setup) || botSelected.languages[0]) || null
            if (nlpSelected) {
                this.props.actions.selectNlpModule(nlpSelected)
            }
            const firstModule = this.getFirstModule(botSelected)
            if (firstModule) {
                this.props.actions.selectModule(firstModule)
            }
        }
    }

    handleChangeModule(e) {
        const { botSelected } = this.props
        const value = e.target.value
        if (botSelected && botSelected.ai && botSelected.ai.nlp && Array.isArray(botSelected.ai.nlp) && botSelected.ai.nlp.length > 0) {
            const moduleSelected = botSelected.ai.nlp.find(module => module && module.name === value)
            if (moduleSelected && moduleSelected.name && (moduleSelected.nlp || moduleSelected.intents || moduleSelected.entities)) {
                const newModule = {
                    name: moduleSelected.name,
                    nlp: moduleSelected.nlp,
                    intents: moduleSelected.intents,
                    entities: moduleSelected.entities
                }
                this.props.actions.selectModule(newModule)
            }
        }
    }

    handleChangeLanguage(e) {
        const value = e.target.value
        const { botSelected } = this.props
        if (botSelected && botSelected.languages && Array.isArray(botSelected.languages)) {
            const nlpSelected = botSelected.languages.find(language => language && language.language === value)
            if (nlpSelected) {
                this.props.actions.selectNlpModule(nlpSelected)
            }
        }
    }

    render() {
        const { app, routing, globalConfig, botSelected, nlpSelected, moduleSelected } = this.props
        const hasMultipleModules = this.hasMultipleModules(botSelected)
        const enabledPages = [
            '/ai',
            '/locale'
        ]
        const disabledPages = [
            '/ai/condition/',
            '/ai/unknownexpression'
        ]

        let warning = ''
        if (!botSelected) {
            warning = 'missing.bot'
        } else if (!nlpSelected) {
            warning = 'missing.language'
        } else if (nlpSelected && !nlpSelected.setup) {
            warning = 'setup'
        }

        let display = 'none'
        if (
            app &&
            app.codename &&
            routing &&
            routing.locationBeforeTransitions &&
            routing.locationBeforeTransitions.pathname &&
            enabledPages.find(enabledPage => routing.locationBeforeTransitions.pathname.startsWith(`/manager/${app.codename}${enabledPage}`)) &&
            !disabledPages.find(disabledPage => routing.locationBeforeTransitions.pathname.startsWith(`/manager/${app.codename}${disabledPage}`))
        ) {
            if (globalConfig && globalConfig.length) {
                if (globalConfig.length > 1) {
                    display = 'block'
                } else if (globalConfig[0].languages && globalConfig[0].languages.length > 1) {
                    display = 'block'
                } else if (hasMultipleModules) {
                    display = 'block'
                }
            } else if (nlpSelected && !nlpSelected.setup) {
                display = 'block'
            } else if (hasMultipleModules) {
                display = 'block'
            }
        }

        return (
            <Container display={display}>
                <Form>
                    {(globalConfig && globalConfig.length) ? (
                        <FormGroup>
                            <ControlLabel>
                                <Translate id="globalConfig.bot" />
                            </ControlLabel>
                            <select
                                key={`botSelected_${botSelected && botSelected.name || 'none'}`}
                                name="bot"
                                value={botSelected && botSelected.bot || undefined}
                                onChange={this.handleChangeBot}
                            >
                                {globalConfig.map((config, index) => (
                                    <option key={`${config.name}_${index}`} value={config.bot}>{config.name}</option>
                                ))}
                            </select>
                        </FormGroup>
                    ) : ''}
                    {hasMultipleModules ? (
                        <FormGroup>
                            <ControlLabel>
                                <Translate id="globalConfig.module" />
                            </ControlLabel>
                            <select
                                key={`moduleSelected_${moduleSelected && moduleSelected.name || 'none'}`}
                                name="module"
                                value={moduleSelected && moduleSelected.name || undefined}
                                onChange={this.handleChangeModule}
                            >
                                {botSelected.ai.nlp
                                    .filter(module => module && module.name)
                                    .map((module, index) => (
                                        <option key={`${module.name}_${index}`} value={module.name}>{module.name}</option>
                                    ))}
                            </select>
                        </FormGroup>
                    ) : ''}
                    {(botSelected && botSelected.languages && botSelected.languages.length) ? (
                        <FormGroup>
                            <ControlLabel>
                                <Translate id="globalConfig.language" />
                            </ControlLabel>
                            <select
                                key={`nlpSelected_${nlpSelected && nlpSelected.language || 'none'}`}
                                name="language"
                                value={nlpSelected && nlpSelected.language || undefined}
                                onChange={this.handleChangeLanguage}
                            >
                                {botSelected.languages.map((language, index) => (
                                    <option key={`${language.language}_${index}`} value={language.language}>{language.name}</option>
                                ))}
                            </select>
                        </FormGroup>
                    ) : ''}
                </Form>
                {warning ? (
                    <Alert bsStyle="warning" style={{ marginTop: '15px', marginBottom: '0px' }}>
                        <Translate id={`globalConfig.${warning}`} />
                    </Alert>
                ) : ''}
            </Container>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        routing: state.routing,
        globalConfig: state.globalConfig,
        botSelected: state.botSelected,
        nlpSelected: state.nlpSelected,
        moduleSelected: state.moduleSelected
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(GlobalConfig)
